import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import picture from '../assets/images/way-white-house.jpg';

function Home() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  return (
    <div className="h-screen bg-cover bg-center flex items-center justify-center px-6 md:px-20 relative overflow-hidden" style={{ backgroundImage: `url(${picture})` }}>
      {/* Overlay for contrast */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      
      <motion.div 
        className="text-center w-full max-w-4xl relative z-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        {/* Luxury Welcome Heading */}
        <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight">
          Welcome to Exclusive Living
        </h1>

        {/* Subtext */}
        <motion.p 
          className="text-lg md:text-2xl mt-6 text-gray-300"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          Discover your dream home and business with the finest real estate offerings.
        </motion.p>

        {/* Call-to-action button */}
        <motion.a
          href="#about"
          className="mt-10 inline-block bg-white text-gray-900 px-10 py-4 md:px-12 md:py-5 rounded-full shadow-xl font-semibold text-lg md:text-xl tracking-wide transition transform hover:scale-105 hover:bg-gray-200"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          Discover More
        </motion.a>
      </motion.div>
    </div>
  );
}

export default Home;
